import { render, staticRenderFns } from "./AtomRadioButtonPrimary.vue?vue&type=template&id=041ed768&"
import script from "./AtomRadioButtonPrimary.vue?vue&type=script&lang=js&"
export * from "./AtomRadioButtonPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports